// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"320": "2f14460b324551ff","333": "67aa4239dcd88158",}[chunkId] + ".css"
}